export default __webpack_public_path__ + "static/media/ZarrarPic.98545a2d.png";